<mat-expansion-panel [expanded]="expanded">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <span [class]="icon + ' light-icon'"></span>
      {{ title }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ng-content select=".accordion-tip-content"></ng-content>
</mat-expansion-panel>
